<template>
  <div class="header-pro-component">
    <NuxtLink
      :to="getLocalizedRoute(Routes.Pro)"
      class="flex flex-row items-center gap-4 py-1 px-3 bg-neutral7 rounded-[0.5rem] transition duration-200 button-pro"
      :title="proTitleAttr">
      <span class="button-pro-logo" v-html="ProIcon" />
      <span class="button-pro-label text-text1 text-sm leading-[1.2]" v-html="proTitleLabel" />
      <span class="button-pro-icon">
        <i class="fa-solid fa-arrow-right"></i>
      </span>
    </NuxtLink>
  </div>
</template>

<script lang="ts" setup>
import getLocalizedRoute from '~/utils/getLocalizedRoute'
import { Routes } from '~/enums/Routes'
import ProIcon from 'assets/icons/pro-logo.svg?raw'
import { useLang } from '~/composables/useLang'
import cleanTags from '~/utils/cleanTags'
const { t } = useLang()

const proTitleAttr = computed(() => cleanTags(t('header.get_us_address_desktop')))
const proTitleLabel = computed(() => t('header.get_us_address_desktop'))
</script>

<style lang="postcss">
.header-pro-component {
  .button-pro {
    @apply dark:invert;

    .button-pro-logo {
      @apply py-1;
    }

    .button-pro-icon {
      @apply text-black;
    }

    &:hover {
      @apply no-underline bg-black;

      .button-pro-logo {
        svg {
          path {
            @apply fill-white;
          }
        }
      }

      .button-pro-label {
        @apply text-white;
      }

      .button-pro-icon {
        @apply text-white;
      }
    }
  }
}
</style>
